<template>
  <transition name="fade">
    <div v-if="visible" class="toast text-center">
      <div class="toast-body">{{ message }}&nbsp;✔</div>
    </div>
  </transition>
</template>
  
  <script>
export default {
  name: "Toast",
  props: {
    message: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.show();
  },
  methods: {
    show() {
      this.visible = true;
      if (this.duration > 0) {
        setTimeout(this.hide, this.duration);
      }
    },
    hide() {
      this.visible = false;
      this.$emit("hidden");
    },
  },
};
</script>
  
<style scoped>
.toast {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #1e1c1d; /* Black background */
  color: #ffffff; /* White text */
  border: 1px solid transparent;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 0.8;
  z-index: 1050;
}

.toast-body {
  font-family: Lexend, sans-serif;
  font-weight: 300;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0.05rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Toast.vue